const langtrans={
      ywcajg:["已完成案件管理","Completed cases management"],
      qssjj:["起始时间","Start time"],
      jjssjj:["结束时间","Finish time"],
      ajbh:["案件编号","Case number"],
      czx:["查询","Check"],
      zwmsss:["暂无数据","Data is temporary not available"],
      xhh:["序号","Serial no."],
      ajbhh:["案件编号","Case no."],
      ffsddd:["发生地点","Case location"],
      yhxm:["用户姓名","User name"],
      yhsjhh:["用户手机号","Mobile no."],
      zjxsxx:["证件信息","ID information"],
      xbb:["性别","Gender"],
      cxsjj:["出险时间","Time of claim"],
      yhbxxq:["用户保险详情","Policy details"],
      bxxqq:["保险详情","Policy details"],
      wm:["无","None"],
      ddqjdd:["当前进度","Current progress"],
      ddqjjd:["当前节点","Current node"],
      hfsjj:["回复时间","Time of reply"],
      cczzz:["操作","Operating Party"],
      jyxqq:["救援详情","Assistance details"],
      jt:["今天","Today"],
      zt:["昨天","Yesterday"],
      yzq:["一周前","A week ago"],
      n:["男","male"],
      nr:["女","female"],
      czkkbb:["查看并操作","Check and operate"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/finish.vue.trans.js